import { NEON_LIGHT_TEXTURE_KEYS } from '.'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/neon-lights/`

  if (!scene.textures.getTextureKeys().includes(NEON_LIGHT_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      NEON_LIGHT_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/animation-neon-lights-images.json`,
      `${prefix}atlas/`,
    )
  }
}
